import type { Ref } from 'vue'
import type { RequestResult } from 'vue-request/dist/types/useRequest'
import type { BaseOptions, FormatOptions } from 'vue-request/dist/types/core/types'

export enum HttpStatus {
  NoLogin = 403,
  NotFound = 404,
  NoPermission = 405,
}

export interface HttpResult<T = any> {
  data?: APIResult<T>
  status?: number
  response?: any
  message?: string
}

export interface APIConfig<T = any> {
  timeout?: number
  noHeader?: boolean
  noPrefix?: boolean
  parser?: (data: T) => void | T
}

export interface APIResult<T = any> {
  data: T
  status: number
  success?: boolean
  msg: string
  code?: number
}
export interface ResolveResult<T = any> {
  error: Boolean
  message?: String
  data?: T
}

export interface APIPromise<T = any> extends Promise<T> {
  parse?: (fn: (data: T) => T) => APIPromise<T>
  resolve?: () => Promise<ResolveResult<T>>
  alert?: () => APIPromise<T>
  cancel?: () => void
  loading?: () => APIPromise<T>
  stopByRef?: (ref: Ref) => Promise<T>
  resolveDefault?: (failValue: any) => Promise<T>
  request?: (
    defaultValue?: any,
    options?: FormatOptions<any, any, any> & BaseOptions<any, any>
  ) => RequestResult<T, any>
}

export type PromiseFn<T> = (...args: any[]) => APIPromise<T>

export interface Pagination<T> {
  records: T[]
  pageNo?: number
  pageSize?: number
  total: number
}
